export default "__VITE_ASSET__99cfd1dd__"